import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {Icon, notification} from "antd";
import {Link} from "react-router-dom";
import {bindActionCreators} from "redux";
import {searchBrands, updateBrandVisibility, showDeleteBrandModal} from "./actions";
import ListView from "../common/ListView";
import DeleteBrandFormModal from "../Brand/DeleteBrandFormModal";

class BrandsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* state */
    dispensaryId: PropTypes.string,
    search: PropTypes.object.isRequired,
    /* actions */
    searchBrands: PropTypes.func.isRequired,
    updateBrandVisibility: PropTypes.func.isRequired,
    showDeleteBrandModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    dispensaryId: null
  };

  onVisibilityClick = async(values) => {
    try {
      await this.props.updateBrandVisibility(values);
      this.listView.refresh();
    } catch (err) {
      notification.error({
        message: 'Failed changing visibility',
        description: err.message,
      });
    }
  };

  render() {
    const {
      history, searchBrands, deleteBrandModalVisible, dispensaryId,
      search: {searching, pagination, filters, sorter, searchFilter, results},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        sorter: true,
        className: 'truncated-column',
      },
      {
        title: 'Visibility',
        key: 'visibility',
        render: (value, {brandId, visibleOnTill}) =>
          <Icon
            type="shopping-cart"
            style={{color: visibleOnTill ? 'green' : 'red', cursor: 'pointer'}}
            onClick={() => this.onVisibilityClick({brandId, visibleOnTill: !visibleOnTill})}
          />
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, brand) => {
          return <span><Link to={`/brand/update/${encodeURIComponent(brand.brandId)}`}>Edit</Link> | <a
            onClick={() => this.props.showDeleteBrandModal(brand)}>Delete</a> </span>
        }
      }
    ];
    return (<React.Fragment>
      {deleteBrandModalVisible && <DeleteBrandFormModal onDelete={() => this.listView.refresh()}/>}
      <ListView
        ref={ref => this.listView = ref}
        dispensaryId={dispensaryId}
        title="Brands"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchBrands}
        dataSource={results}
        pagination={pagination}
        searchFilter={searchFilter}
        filters={filters}
        sorter={sorter}
        onAdd={() => history.push('/brand/add')}
        rowKey="brandId"
      />
    </React.Fragment>);
  }
}

const mapStateToProps = state => ({
  loading: state.brand.brandsLoading,
  dispensaryId: state.dispensary.selectedDispensaryId,
  search: state.brand.search,
  deleteBrandModalVisible: state.brand.deleteBrandModalVisible,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchBrands,
  updateBrandVisibility,
  showDeleteBrandModal,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(BrandsPage);



// WEBPACK FOOTER //
// ./src/Brand/BrandsPage.js